module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/gift-cards@2x_866c9a.jpg";